var _excluded = ["content", "color", "header", "onPrimaryClick", "onSecondaryClick", "onBackClick", "primaryButton", "primaryButtonProps", "secondaryButton", "secondaryButtonProps", "backButton", "backButtonProps"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import { useDataTestId } from '@jvs-group/jvs-mairistem-tools';
import { Button, Modal } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A confirmation modal.
 */
var ModalConfirm = function ModalConfirm(props) {
  var content = props.content,
    color = props.color,
    header = props.header,
    onPrimaryClick = props.onPrimaryClick,
    onSecondaryClick = props.onSecondaryClick,
    onBackClick = props.onBackClick,
    primaryButton = props.primaryButton,
    primaryButtonProps = props.primaryButtonProps,
    secondaryButton = props.secondaryButton,
    secondaryButtonProps = props.secondaryButtonProps,
    backButton = props.backButton,
    backButtonProps = props.backButtonProps,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var modalConfirmDataTestId = useDataTestId('collection-modal-confirm');
  var modalConfirmBackDataTestId = useDataTestId('collection-modal-confirm-back');
  var modalConfirmSecondaryDataTestId = useDataTestId('collection-modal-confirm-secondary');
  var modalConfirmPrimaryDataTestId = useDataTestId('collection-modal-confirm-primary');
  return /*#__PURE__*/_jsxs(Modal, Object.assign({
    "data-testid": modalConfirmDataTestId,
    open: true,
    size: "tiny",
    colorHeader: color
  }, backButton && {
    closeOnDimmerClick: true,
    closeIcon: true,
    onClose: onBackClick
  }, rest, {
    children: [/*#__PURE__*/_jsx(Modal.Header, {
      children: header
    }), !_.isNil(content) && content !== true && /*#__PURE__*/_jsx(Modal.Content, {
      children: content
    }), /*#__PURE__*/_jsxs(Modal.Actions, {
      children: [backButton && /*#__PURE__*/_jsx("div", {
        style: {
          "float": 'left'
        },
        children: /*#__PURE__*/_jsx(Button, Object.assign({
          "data-testid": modalConfirmBackDataTestId,
          basic: true,
          size: "tiny",
          icon: "arrow left",
          content: "Retour",
          onClick: onBackClick
        }, backButtonProps))
      }), secondaryButton && /*#__PURE__*/_jsx(Button, Object.assign({
        "data-testid": modalConfirmSecondaryDataTestId,
        basic: true,
        size: "tiny",
        icon: "cancel",
        content: "Non",
        onClick: onSecondaryClick
      }, secondaryButtonProps)), primaryButton && /*#__PURE__*/_jsx(Button, Object.assign({
        "data-testid": modalConfirmPrimaryDataTestId,
        positive: true,
        icon: "check",
        content: "Oui",
        onClick: onPrimaryClick
      }, primaryButtonProps))]
    })]
  }));
};
ModalConfirm.handledProps = ["backButton", "backButtonProps", "color", "content", "header", "onBackClick", "onPrimaryClick", "onSecondaryClick", "primaryButton", "primaryButtonProps", "secondaryButton", "secondaryButtonProps"];
ModalConfirm.defaultProps = {
  color: null,
  header: 'Confirmation',
  primaryButton: true,
  primaryButtonProps: null,
  onPrimaryClick: null,
  secondaryButton: false,
  secondaryButtonProps: null,
  onSecondaryClick: null,
  backButton: true,
  backButtonProps: null,
  onBackClick: null,
  content: null
};
export default ModalConfirm;